import tinycolor from 'tinycolor2';
import { toRefs, computed } from 'vue';
import { useButton } from '../button/component-lib.esm.js';
import { useTheme } from '../../compositions/component-lib.esm7.js';
import { getThemeColor } from '../../styles/theme/component-lib.esm3.js';
import { colors } from '../../styles/component-lib.esm2.js';

//
var script = {
  name: 'InlineLink',
  props: {
    component: {
      type: String,
      default: 'button'
    },
    color: {
      type: String,
      default: 'primary'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  setup(props, _ref) {
    let {
      attrs
    } = _ref;
    const {
      component,
      color
    } = toRefs(props);
    const theme = useTheme();
    const {
      buttonTag,
      buttonType
    } = useButton({
      component,
      ...attrs
    });
    const styles = computed(() => {
      const themeColor = getThemeColor(color.value, theme.value);
      return {
        '--c-color': themeColor,
        '--c-color-active': tinycolor(themeColor).darken(),
        '--c-color-disabled': colors.grayDark
      };
    });
    return {
      buttonTag,
      buttonType,
      styles
    };
  }
};
export { script as default };